import { Post } from "../../home/Home";
import { Post as PostView } from "../Post";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../App";
import { collection, getDocs, query, where, documentId } from "firebase/firestore";
import { db, auth } from "../../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { UpdatePost } from "../updatepost/UpdatePost";

export const EditPost = () => {
  const { selectedPostId } = useContext(AppContext);
  const [post, setPost] = useState<Post | null>(null);
  const [user, loading, error] = useAuthState(auth);
  const postRef = collection(db, "posts");

  const getPost = async () => {
    try {
      const postToEditQuery = query(postRef, where(documentId(), "==", selectedPostId));
      const data = await getDocs(postToEditQuery);
      const doc = data.docs[0];
      setPost({ ...doc.data(), id: doc.id } as Post);
    } catch (error) {}
  };
  useEffect(() => {
    if (user) {
      getPost();
    }
  }, [user]);
  return (
    <>
      {user?.uid === post?.userId ? (
        <div>
          {post && (
            <>
              <div className='w-50 mx-auto'>
                <PostView
                  post={{
                    userId: post.userId,
                    description: post.description,
                    title: post.title,
                    username: post.username,
                    likeCount: post.likeCount,
                    id: post.id,
                  }}
                />
              </div>
              <UpdatePost title={post.title} description={post.description} postId={post.id} />
            </>
          )}
          {!post && <p className='alert alert-danger'>Something went wrong while loading post. Try again later.</p>}
        </div>
      ) : (
        <p className='alert alert-danger'>Authentication error. Try again later.</p>
      )}
    </>
  );
};
